import config from '@/config';
import axios from 'axios';

export const apiClient = axios.create({
  baseURL: config.api.url,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

